import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import EventEmitter from 'wolfy87-eventemitter';
import { supportsPassiveEvents } from 'detect-passive-events';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var passiveEvents = ['scroll', 'touchstart', 'touchend', 'touchmove'];

var EventsManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(EventsManager, _EventEmitter);

  var _super = _createSuper(EventsManager);

  function EventsManager(element) {
    var _this;

    _classCallCheck(this, EventsManager);

    _this = _super.call(this);
    _this.element = element;
    _this.events = {};
    _this.listeners = {};
    return _this;
  }

  _createClass(EventsManager, [{
    key: "subscribe",
    value: function subscribe(event, callback) {
      this.on(event, callback);
      this.events = _objectSpread(_objectSpread({}, this.events), {}, _defineProperty({}, event, [].concat(_toConsumableArray(this.events[event] || []), [callback])));

      if (this.events[event].length === 1) {
        this.addEventListener(event);
      }
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(event, callback) {
      var _this2 = this;

      this.off(event, callback);
      this.events = Object.keys(this.events).reduce(function (newEvents, eventName) {
        if (eventName !== event) {
          return _objectSpread(_objectSpread({}, newEvents), {}, _defineProperty({}, eventName, _this2.events[eventName]));
        }

        var newListeners = _this2.events[eventName].filter(function (listener) {
          return listener !== callback;
        });

        return newListeners.length > 0 ? _objectSpread(_objectSpread({}, newEvents), {}, _defineProperty({}, eventName, newListeners)) : newEvents;
      }, {});

      if (typeof this.events[event] === 'undefined') {
        this.removeEventListener(event);
      }
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(event) {
      var _this3 = this;

      if (typeof this.listeners[event] === 'undefined') {
        this.listeners[event] = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _this3.emit.apply(_this3, [event].concat(args));
        };
      }

      var needsPassive = passiveEvents.indexOf(event) !== -1;

      if (needsPassive && supportsPassiveEvents === true) {
        this.element.addEventListener(event, this.listeners[event], {
          passive: true
        });
        return;
      }

      if (needsPassive && supportsPassiveEvents === false) {
        this.element.addEventListener(event, this.listeners[event], false);
        return;
      }

      this.element.addEventListener(event, this.listeners[event]);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(event) {
      this.element.removeEventListener(event, this.listeners[event]);
    }
  }]);

  return EventsManager;
}(EventEmitter);

export { EventsManager, EventsManager as default, passiveEvents };
